import React, { createContext, useState, useEffect, useCallback } from "react";
import getServices from "../Services/get-service";
import cookie from "react-cookies";
import { toast } from "react-toastify";
import { Logout } from "@mui/icons-material";

// context object for sharing user data across the application
export const UserContext = createContext();

// Define the Provider component which wraps the app and manages user state
export const UserProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(!!(cookie.load("token") || cookie.load("jwttoken")));
  const [loading, setLoading] = useState(true);

  // Function responsible for calling the get-user-profile API
  const fetchUserProfile = useCallback(() => {
    const token = cookie.load("token") || cookie.load("jwttoken");

    if (token) {
      setLoading(true);
      getServices
        .getUserProfile()
        .then((response) => {
          if (response?.data?.statusCode === 200) {
            setUserDetails(response.data.data);
            setIsLoggedIn(true);
          } else {
            // If profile fetch fails with a token present redirect to login
            setIsLoggedIn(false);
            Logout()
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response.data.description);
        });
    } else {
      setIsLoggedIn(false);
      setLoading(false);
    }
  }, []);

  const login = (token, user = null) => {
    const expiry = new Date(Date.now() + 15 * 60 * 1000); // 15 minutes
    cookie.save("token", token, { path: "/", expires: expiry });
    cookie.save("jwttoken", token, { path: "/", expires: expiry });
    setIsLoggedIn(true);
    if (user && user.firstName) {
      setUserDetails(user);
    }
    fetchUserProfile();
  };

  const logout = () => {
    cookie.remove("token", { path: "/" });
    cookie.remove("jwttoken", { path: "/" });
    setUserDetails(null);
    setIsLoggedIn(false);
  };

  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);

  return (
    <UserContext.Provider
      value={{
        userDetails,
        setUserDetails,
        isLoggedIn,
        setIsLoggedIn,
        loading,
        refreshUserProfile: fetchUserProfile,
        login,
        logout,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
